import { JetView } from 'webix-jet';

/**
 * Class representing the detailsPlayersReportView.
 * Extends JetView to create a specific view for player details report.
 */
export default class detailsPlayersReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const left = {
            view: 'toolbar',
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Apply the theme to the toolbar
                    elements: [{ view: 'label', label: _('Detalles') }], // Label for the toolbar
                },
            ],
        };
        return {
            height: screen !== 'small' ? 300 : 230, // Set height based on screen size
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID changes
        });
    }
}

// FILE DOCUMENTED
